/**
 * Package: nfosongcycleMain
 *
 * NFO Song Cycle site object; init is run on document ready.
 */

/**
 * Safe(r) shortcut for jQuery.
 */
if ( !$j ) {
    var $j = jQuery.noConflict();
}

var count = 0;
        
var nfosongcycleMain = {
    /**
     * Initialize site on document ready: set up hover groups, carousels, and other UI components.
     *
     * @return void
     */
    init: function() {
        nfosongcycleMain.initMobileAccordionScroll();
        nfosongcycleMain.initCarousels();
        nfosongcycleMain.removeGFStyles();
        nfosongcycleMain.linkCardGroups();
        
        // Run methods that need to know about resize
        $j( window ).on( 'resize', function() {
            
        } );
    },
    
    /**
     * Scrolls to the top of mobile accordions when a new one opens
     *
     * @return void
     */
    initMobileAccordionScroll: function() {

        const mobileAccordion = document.getElementById('case-study-accordion');
        if ( !mobileAccordion ) return;
        
        mobileAccordion.addEventListener('hidden.bs.collapse', event => {
            $j([document.documentElement, document.body]).animate({
                scrollTop: $j('.accordion-button.show').offset().top - 69
            }, 0);
        });

    },

    carousels: [],
    /**
     * Initialize all Bootstrap carousels on the page and set up play/pause controls.
     *
     * @return void
     */
    initCarousels: function() {
        
        // Init any carousels
        $j('.carousel').map( function() {
            
            var carousel = new bootstrap.Carousel( $j( this ) );
            carousel.cycle();

            // Pause videos playing in carousel on slide change
            $j('.carousel').on( 'slide.bs.carousel', function() {
                $j( this ).find( 'hls-video' ).each( function() {
                    this.pause();
                });
            });
            
            nfosongcycleMain.carousels.push( { 
                carousel: carousel,
                containerId: $j( this ).attr( 'id' ),
            } );
        
        });

        // Pause carousel when user selects a slide to view
        $j('.carousel-indicators .indicator').on( 'click', function() {

            var id = $j( this ).parents('.carousel').attr('id');

            nfosongcycleMain.carousels.forEach( function( currentValue ) {
                if ( currentValue.containerId == id ) {
                    currentValue.carousel.pause();
                }
            } );
        
        });
        
        // Play/pause button for carousels
        // Not implemented on front end currently
        $j('a.pause').on( 'click', function() {
            
            var id = $j( this ).siblings('.carousel').attr('id');
            
            if( $j('a.paused').length == 1 ) {
                
                $j('a.pause').removeClass('paused').children('.fa-solid').removeClass('fa-play').addClass('fa-pause');
                
                nfosongcycleMain.carousels.forEach( function( currentValue ) {
                    if ( currentValue.containerId == id ) {
                        currentValue.carousel.next();
                        currentValue.carousel.cycle();
                    }
                } );
            
            } else {
                
                $j('a.pause').addClass('paused').children('.fa-solid').addClass('fa-play').removeClass('fa-pause');
               
                nfosongcycleMain.carousels.forEach( function( currentValue ) {
                    if ( currentValue.containerId == id ) {
                        currentValue.carousel.pause();
                    }
                } );
            
            }
        
        });
    
    },

    /**
     * Remove default Gravity Forms inline styles and related CSS links.
     *
     * @return void
     */
    removeGFStyles: function() {
        
        $j('.gf_browser_safari').attr( 'class', '' ).prev('style').remove();
        $j('link[id^="gravity_forms"]').remove();
        $j('#stla_bootstrap_frontend-css').remove();
    
    },

    /**
     * Better method of linking card groups
     * - Automatically clones the link ID'd by data-link-id as an overlay
     * - Sets .hover on the card when the overlay is hovered for linking hover states
     */
    linkCardGroups: function() {
        $j( '.link-group-card' ).each( function( id, val ) { 
            var card = $j( this );
            var link = $j( '#' + card.data( 'link-id' ) ).clone( true );
            
            link.html( '' ).addClass( 'link-overlay' );
            
            link.on( 'mouseenter', function() {
            
                card.addClass( 'hover' );
            
            }).on( 'mouseleave', function() {
                
                card.removeClass( 'hover' );
            
            });
            
            card.append( link );
        });
    },
 
};

// Call init on ready
$j( nfosongcycleMain.init );
